export default {
    props: {
        keep: {
            type: Boolean,
        },
    },
    beforeMount() {
        this.$options.defaultData = JSON.parse(JSON.stringify(this.$data));
    },
    methods: {
        resetData() {
            Object.assign(this.$data, this.$options.defaultData);
        },
    },
}

// TODO: Возможно пригодиться
// https://github.com/vuejs/vue/issues/702
// https://github.com/vuejs/vue/issues/702#issuecomment-308991548
// Object.assign(this.$data, this.$options.data.apply(this))